<template>
	<div class="safe-content">
		<ul class="safe-list">
			<li>
				<img src="../../assets/img/setting/mima@2x.png" />
				<p class="safe-title">登录密码</p>
				<p class="safe-desc">建议您定期更换密码，设置安全性高的密码可以可以使账号更安全</p>
				<button class="safe-btn" @click="modifyFlag = true">重置</button>
			</li>
			<li>
				<img src="../../assets/img/setting/shouji@2x.png" />
				<p class="safe-title">安全手机 {{telephone_}}</p>
				<p class="safe-desc">安全手机可以用于登录了账号，重置密码或其他安全验证</p>
				<router-link class="safe-btn" to="changePhone">更换</router-link>
			</li>
		</ul>

		<ss-modal v-model="modifyFlag" maskClose="false">
			<div class="modify-box">
				<p class="modify-title">修改密码</p>
				<div class="modify-input-group">
					<div class="modify-input-title">原密码</div>
					<input class="modify-input" type="password" v-model="formData.oldpsw" placeholder="请输入原密码" />
				</div>
				<div class="modify-input-group">
					<div class="modify-input-title">新密码</div>
					<input class="modify-input" type="password" v-model="formData.psw" placeholder="请设置6至20位登录密码" />
					<input class="modify-input" type="password" v-model="password" placeholder="请再次输入登录密码" />
				</div>
				<div class="modify-btn-group clearfix">
					<button class="modify-btn" @click="modify">同意</button>
					<button class="modify-btn" @click="modifyFlag = false">不同意</button>
				</div>
			</div>
		</ss-modal>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import {
		desEncrypt
	} from '@/utils';
	export default {
		data() {
			return {
				formData: {
					oldpsw: '',
					psw: ''
				},
				password: '',
				modifyFlag: false,
				userInfo: {}
			}
		},
		mounted() {
			console.log('mounted');
			// 'Please confirm to continue' ,

		},
		computed: {
			telephone_ () {
				let telephone = this.userInfo.telephone;
				return telephone ? telephone.substr(0, 3) + '****' + telephone.substr(7, 4) : '';
			}
		},
		created() {
			this.getUserInfo();
		},
		methods: {
			...mapActions('user', ['GetUserInfoHandle']),
			async getUserInfo() {
				this.userInfo = await this.GetUserInfoHandle(false);
			},
			async modify() {
				if (!this.formData.oldpsw) {
					return this.$toast('请输入旧密码');
				}
				if (!this.formData.psw) {
					return this.$toast('请输入新密码');
				}
				if (!this.password) {
					return this.$toast('请再次输入新密码');
				}
				//校验密码格式，长度6-20位
				if(this.formData.psw.length < 6 || this.formData.psw.length > 20) {
					return this.$toast('请设置6至20位的登录密码');
				}
				if (this.formData.psw !== this.password) {
					return this.$toast('两次密码不一致');
				}
				let params = this.$deepClone(this.formData);
				Object.keys(params).forEach(key => {
					params[key] = desEncrypt(params[key]);
				})
				let res = await this.$http('updatePwd', params);
				if (res.code === 1) {
					this.modifyFlag = false;
				}
			}
		}
	}
</script>

<style lang="scss">
	.safe-content {
		padding: 20px 220px 20px 60px;

		.modify-box {
			width: 546px;
			background: #FFFFFF;
			padding: 30px 105px 60px;
			box-shadow: 1px 7px 73px 0px rgba(0, 0, 0, 0.25);
			border-radius: 5px;

			.modify-btn-group {
				margin-top: 46px;
				padding-right: 37px;

				.modify-btn {
					width: 50%;
					float: left;
					width: 150px;
					height: 50px;
					line-height: 48px;
					background: #0260FC;
					border-radius: 25px;
					font-size: 18px;
					font-weight: 400;
					color: #FFFFFF;
					line-height: 35px;
					border: 1px solid #0260FC;
					text-align: center;

					&+.modify-btn {
						background-color: #fff;
						color: #0260FC;
						float: right;
						margin-right: -37px;
					}
				}
			}

			.modify-input-group {
				margin-top: 45px;

				&+.modify-input-group {
					margin-top: 25px;
				}

				.modify-input-title {
					font-size: 18px;
					font-weight: 400;
					color: #484848;
				}

				.modify-input {
					margin-top: 10px;
					width: 100%;
					display: block;
					height: 44px;
					line-height: 42px;
					background: #FFFFFF;
					border: 1px solid #DEDEDE;
					border-radius: 3px;
					padding: 0 10px;
					color: #333;
					font-weight: 400;
					font-size: 15px;

					&+.modify-input {
						margin-top: 20px;
					}
				}
			}

			.modify-title {
				text-align: center;
				font-size: 24px;
				font-weight: bold;
				color: #484848;
			}
		}

		.safe-list {
			li {
				padding: 38px 0 38px 98px;
				position: relative;
				border-bottom: 1px solid #DDDDDD;

				&+li {
					margin-top: 18px;
				}

				img {
					@include abs(45px, null, null, 15px);
					width: 35px;
					display: block;
				}

				.safe-title {
					font-size: 20px;
					font-weight: 400;
					color: #333333;
					line-height: 30px;
				}

				.safe-desc {
					margin-top: 5px;
					font-size: 16px;
					font-weight: 400;
					color: #999999;
					line-height: 30px;
				}

				.safe-btn {
					margin-top: 15px;
					width: 160px;
					height: 40px;
					background: #F4F5F6;
					border: 1px solid #B5B5B5;
					text-align: center;
					line-height: 38px;
					display: block;
					font-size: 16px;
					font-weight: 400;
					color: #7A7A7A;
				}
			}
		}
	}
</style>
